<template>
  <div class="page-scans-filter">
    <v-card>
      <v-card-title class="bg-grey-lighten-3 mb-3 border-b" v-show="scanFilterStateV2.settings.filterTitle != ''">
        {{scanFilterStateV2['settings']['filterTitle']}}
      </v-card-title>
      <v-card-text>
        <div v-if="!props.scanFilterStateV2.isLoading && displayFilters">

          <div v-if="showScansStartDate != '' && showScansEndDate != ''" >
            <span class="filter-chip">
              <v-icon icon="mdi-clock" /> <b>From:</b> {{ getDate(showScansStartDate, 'MMM DD, YYYY h:mm A') }}<br>
              <b>To:</b> {{ getDate(showScansEndDate, 'MMM DD, YYYY h:mm A') }} <v-icon icon="mdi-close" @click="removeSearchParameter(['period', 'p_number', 'p_metric'])" />
            </span>
          </div>

          <div v-if="scanStartDate != '' && scanEndDate == ''" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-clock" /> <b>Starting from:</b> {{getDate(scanDateFrom, 'MMM DD, YYYY h:mm A')}} <v-icon icon="mdi-close" @click="removeSearchParameter(['start_date'])" />
            </span>
          </div>

          <div v-if="scanStartDate == '' && scanEndDate != ''" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-clock" /> <b>Ending at:</b> {{getDate(scanDateTo, 'MMM DD, YYYY h:mm A')}} <v-icon icon="mdi-close" @click="removeSearchParameter(['end_date'])" />
            </span>
          </div>

          <div v-if="scanStartDate != '' && scanEndDate!= ''" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-clock" /> <b>From</b> {{getDate(scanDateFrom, 'MMM DD, YYYY h:mm A')}} <b>To</b> {{getDate(scanDateTo, 'MMM DD, YYYY h:mm A')}} <v-icon icon="mdi-close" @click="removeSearchParameter(['start_date', 'end_date'])" />
            </span>
          </div>

          <div v-if="scanClone.value != ''" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-magnify" />  <b>Value:</b>
              {{ scanClone.value.length > 150 && !showValueMore ? scanClone.value.slice(0, 149) + '...' : scanClone.value }}
              <span  class="handle" v-if="scanClone.value.length > 150">
                (<u @click="showValueMore = !showValueMore">
                  <u v-show="!showValueMore">show more</u>
                  <u v-show="showValueMore">show less</u>
                </u>)
              </span> <v-icon icon="mdi-close" @click="removeSearchParameter(['value'])" />
            </span>
          </div>

          <div v-if="scanClone.response != ''" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-magnify" /> <b>Response:</b>
              {{ scanClone.response.length > 150 && !showResponseMore ? scanClone.response.slice(0, 149) + '...' : scanClone.response  }}
              <span class="handle" v-if="scanClone.response.length > 150">
                (<u @click="showResponseMore = !showResponseMore">
                  <u v-show="!showResponseMore">show more</u>
                  <u v-show="showResponseMore">show less</u>
                </u>)
              </span> <v-icon icon="mdi-close" @click="removeSearchParameter(['response'])" />
            </span>
          </div>

          <div v-if="scanClone.property_name != '' && scanClone.property_value != ''" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-magnify" />
              <b>Property:</b>
              <em>Name</em> - {{ scanClone['property_name'].length > 100 && !showPropertyName ? scanClone['property_name'].slice(0, 99) + '...' : scanClone['property_name'] }}
              <span class="handle" v-show="scanClone.property_name.length > 100">
                (<u @click="showPropertyName = !showPropertyName">
                  <u v-show="!showPropertyName">show more</u>
                  <u v-show="showPropertyName">show less</u>
                </u>)
              </span>
              &nbsp;<em>Value</em> - {{ scanClone['property_value'].length > 100 && !showPropertyValue ? scanClone['property_value'].slice(0, 99) + '...' : scanClone['property_value'] }}
              <span class="handle" v-show="scanClone.property_value.length > 100">
                (<u @click="showPropertyValue = !showPropertyValue">
                  <u v-show="!showPropertyValue">show more</u>
                  <u v-show="showPropertyValue">show less</u>
                </u>)
              </span>  <v-icon icon="mdi-close" @click="removeSearchParameter(['property'])" />
            </span>
          </div>

          <div v-if="scanClone.property_name != '' && scanClone.property_value != ''" class="mt-2" >
            <span class="filter-chip">
              <v-icon icon="mdi-help" />
              <b>Answer:</b>
              {{ scanClone['answer'].length > 150 && !showAnswerMore ? scanClone['answer'].slice(0, 149) + '...' : scanClone['answer']  }}
              <span class="handle" v-show="scanClone.answer.length > 150">
                (<u @click="showAnswerMore = !showAnswerMore">
                  <u v-show="!showAnswerMore">show more</u>
                  <u v-show="showAnswerMore">show less</u>
                </u>)
              </span> <v-icon icon="mdi-close" @click="removeSearchParameter(['answer'])" />
            </span>
          </div>

          <div v-if="scanClone.recent_scan" class="mt-2">
            <span class="filter-chip">
              {{ scanClone.recent_scan ? 'Recent Scan' : '' }} <v-icon icon="mdi-close" @click="removeSearchParameter(['recent_scan'])" />
            </span>
          </div>

          <div v-if="scanClone.table_builder_scan" class="mt-2">
            <span class="filter-chip">
              {{ scanClone.table_builder_scan ? 'Only active Table Builder records' : '' }} <v-icon icon="mdi-close" @click="removeSearchParameter(['table_builder_scan'])" />
            </span>
          </div>

          <div v-if="scanClone.exclude_table_builder_scan" class="mt-2">
            <span class="filter-chip">
              {{ scanClone.exclude_table_builder_scan ? 'Exclude Table Builder records' : '' }} <v-icon icon="mdi-close" @click="removeSearchParameter(['exclude_table_builder_scan'])" />
            </span>
          </div>

          <div v-if="scanClone.check_in_out_scan" class="mt-2">
            <span class="filter-chip">
              {{ scanClone.check_in_out_scan ? 'Only active Check IN/OUT records' : '' }} <v-icon icon="mdi-close" @click="removeSearchParameter(['check_in_out_scan'])" />
            </span>
          </div>

          <div v-if="scanClone.exclude_check_in_out_scan" class="mt-2">
            <span class="filter-chip">
              {{ scanClone.exclude_check_in_out_scan ? 'Exclude Check IN/OUT records' : '' }} <v-icon icon="mdi-close" @click="removeSearchParameter(['exclude_check_in_out_scan'])" />
            </span>
          </div>

          <div v-if="scanClone.category != 'all'" class="mt-2">
            <span class="filter-chip">
              {{ scanClone.category == 'real_time' ? 'Real-time Scans' : 'Uploaded Scans' }} <v-icon icon="mdi-close" @click="removeSearchParameter(['category'])" />
            </span>
          </div>

          <div v-if="scanClone.selected_ids != ''" class="mt-2">
            <span class="filter-chip">
              <b>Scan ID:</b> {{ scanClone['selected_ids'] }} <v-icon icon="mdi-close" @click="removeSearchParameter(['scan_ids'])" />
            </span>
          </div>

          <div v-if="scanClone.result != 'all' && scanClone.result.length != 3 && scanClone.result.length != 0" class="mt-2">
            <span class="filter-chip">
              <span v-if="scanClone.result.indexOf('0') != -1 &&  scanClone.result.length == 1">
                <img :src="asset('icon/invalid-small.png')" alt="invalid icon" />
                Only Invalid Scans &nbsp;
              </span>
              <span v-if="scanClone.result.indexOf('1') != -1 &&  scanClone.result.length == 1">
                <img :src="asset('icon/valid-small.png')"  alt="valid icon"/>
                Only Valid Scans &nbsp;
              </span>
              <span v-if="scanClone.result.indexOf('-1') != -1 &&  scanClone.result.length == 1">
                <img :src="asset('icon/saved-small.png')" alt="saved icon" />
                Only Saved Scans &nbsp;
              </span>
              <span v-if="scanClone.result.indexOf('1') != -1 &&  scanClone.result.indexOf('-1') != -1 && scanClone.result.length == 2">
                <img :src="asset('icon/valid-small.png')" alt="valid icon" />
                <img :src="asset('icon/saved-small.png')" alt="saved icon"/>
                Only Valid and Saved Scans &nbsp;
              </span>
              <span v-if="scanClone.result.indexOf('1') != -1 &&  scanClone.result.indexOf('0') != -1 && scanClone.result.length == 2">
                <img :src="asset('icon/valid-small.png')" alt="valid icon"/>
                <img :src="asset('icon/invalid-small.png')" alt="invalid icon"/>
                Only Valid and Invalid Scans &nbsp;
              </span>
              <span v-if="scanClone.result.indexOf('0') != -1 &&  scanClone.result.indexOf('-1') != -1 && scanClone.result.length == 2">
                <img :src="asset('icon/invalid-small.png')" alt="invalid icon"/>
                <img :src="asset('icon/saved-small.png')" alt="saved icon" />
                Only Invalid and Saved Scans &nbsp;
              </span> <v-icon icon="mdi-close" @click="removeSearchParameter(['result'])" />
            </span>
          </div>

          <div v-if="uploads.length > 0 " class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-upload-box-outline" /> <b>Uploaded: </b> <template v-if="uploadTimestamps"> on {{getDate(uploadTimestamps, 'MMM DD, YYYY h:mm A')}}</template> <v-icon icon="mdi-close" @click="removeSearchParameter(['uploads'])" />
            </span>
          </div>

          <div v-if="!scanFilterStateV2.settings.services.select_all && services.length == 0 && deletedServices" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-file" /> Only Deleted Services <v-icon icon="mdi-close" @click="removeSearchParameter(['d_services'])" />
            </span>
          </div>

          <div v-if="!scanFilterStateV2.settings.users.select_all && users.length == 0 && deletedUsers" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-account" /> Only Deleted Users <v-icon icon="mdi-close" @click="removeSearchParameter(['d_users'])" />
            </span>
          </div>

          <div v-if="serviceNames.length > 0" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-file" /> <b>Services: </b> {{ serviceNames }} {{deletedServices ? ', All Deleted Services' : ''}} <v-icon icon="mdi-close" @click="removeSearchParameter(deletedServices ? ['service_ids', 'd_services'] : ['service_ids'])" />
            </span>
          </div>

          <div v-if="userNames.length > 0" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-account" /> <b>Users: </b> {{ userNames }} {{deletedUsers ? ', All Deleted Users' : ''}} <v-icon icon="mdi-close" @click="removeSearchParameter(deletedUsers ? ['user_ids', 'd_users'] : ['user_ids'])" />
            </span>
          </div>

          <div v-if="deviceNames.length > 0" class="mt-2">
            <span class="filter-chip">
              <v-icon icon="mdi-cellphone-sound" /> <b>Devices: </b> {{ deviceNames }} <v-icon icon="mdi-close" @click="removeSearchParameter(['device_ids'])" />
            </span>
          </div>
        </div>
        <v-divider class="border-opacity-50 mt-2 mb-2" />

        <v-form @submit.prevent="filter" class="mt-2">
          <v-expansion-panels v-model="panel" variant="accordion" multiple>
            <v-expansion-panel :class="{ 'bg-grey-lighten-4 my-1': panel.includes(0) }" elevation="0">
              <v-expansion-panel-title class="font-weight-bold px-0 my-n3 text-body-2" hide-actions>
                <div class="bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2">
                  <v-icon class="mt-n1" size="x-large" :icon="panel.includes(0) ? 'mdi-menu-down' : 'mdi-menu-right'" /> <v-icon icon="mdi-magnify" />Search Options
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div>
                  <label class="my-2 d-block">Barcode Value</label>
                  <v-text-field variant="outlined" placeholder="Barcode Value" v-model="scanFilterStateV2.settings.scan.value" density="compact" hide-details />
                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-checkbox v-model="scanFilterStateV2.settings.scan.exact_value" label="Exact Phrase" density="compact" hide-details />
                    </v-col>
                    <v-col cols="6">
                      <v-checkbox v-model="scanFilterStateV2.settings.scan.value_ci" label="Case Insensitive" density="compact" hide-details />
                    </v-col>
                  </v-row>
                </div>

                <div class="my-4">
                  <label class="mb-2 d-block">Search Response</label>
                  <v-text-field variant="outlined" placeholder="Search Response" v-model="scanFilterStateV2.settings.scan.response" density="compact" hide-details />
                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-checkbox v-model="scanFilterStateV2.settings.scan.exact_response" label="Exact Phrase" density="compact" />
                    </v-col>
                    <v-col cols="6">
                      <v-checkbox v-model="scanFilterStateV2.settings.scan.response_ci" label="Case Insensitive" density="compact" />
                    </v-col>
                  </v-row>
                </div>

                <div v-if="scanFilterStateV2.showAnswersAndPropertyInputs">
                  <div>
                    <label class="d-block mb-2">Search Answers</label>
                    <v-text-field variant="outlined" placeholder="Search Answers" v-model="scanFilterStateV2.settings.scan.answer" density="compact" hide-details />
                    <v-checkbox v-model="scanFilterStateV2.settings.scan.exact_answer" label="Exact Phrase" density="compact" />
                  </div>

                  <v-label class="d-block mb-2">Search Property</v-label>
                  <v-text-field variant="outlined" label="Name" v-model="scanFilterStateV2.settings.scan.property_name" density="compact" />
                  <v-text-field variant="outlined" label="Value" v-model="scanFilterStateV2.settings.scan.property_value" density="compact" />
                </div>

                <div :class="{'has-error': scanFilterStateV2.showErrorForScanIds == true}">
                  <label class="d-block mb-2">Scan Ids</label>
                  <v-text-field variant="outlined" placeholder="Scan Ids" v-model="scanFilterStateV2.settings.scan.selected_ids" density="compact" @change="validateScanIds(scanFilterStateV2.settings.scan.selected_ids)"  hide-details />
                  <small>You can enter multiple comma-separated scan ID</small>
                </div>

                <v-checkbox v-model="scanFilterStateV2.settings.scan.recent_scan" label="Only recent scan for each barcode" density="compact" class="mt-5" hide-details />
                <v-checkbox v-model="scanFilterStateV2.settings.scan.table_builder_scan" :disabled="scanFilterStateV2.settings.scan.exclude_table_builder_scan" label="Only active Table Builder records" density="compact" hide-details />
                <v-checkbox v-model="scanFilterStateV2.settings.scan.exclude_table_builder_scan" :disabled="scanFilterStateV2.settings.scan.table_builder_scan" label="Exclude Table Builder records" density="compact" hide-details />
                <v-checkbox v-model="scanFilterStateV2.settings.scan.check_in_out_scan" :disabled="scanFilterStateV2.settings.scan.exclude_check_in_out_scan" label="Only active Check IN/OUT records" density="compact" hide-details />
                <v-checkbox v-model="scanFilterStateV2.settings.scan.exclude_check_in_out_scan" :disabled="scanFilterStateV2.settings.scan.check_in_out_scan" label="Exclude Check IN/OUT records" density="compact" hide-details />
              </v-expansion-panel-text>
            </v-expansion-panel>

            <v-expansion-panel :class="{ 'bg-grey-lighten-4 my-1': panel.includes(1) }" elevation="0">
              <v-expansion-panel-title class="font-weight-bold px-0 my-n3 text-body-2" hide-actions>
                <div class="bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2">
                  <v-icon class="mt-n1" size="x-large" :icon="panel.includes(1) ? 'mdi-menu-down' : 'mdi-menu-right'" /> <v-icon icon="mdi-calendar-today" /> Date and Order
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-radio-group v-model="scanFilterStateV2.settings.scan.data_received" class="mt-3">
                  <v-radio label="Date Scanned" :value="0" density="compact" />
                  <v-radio label="Date Received" :value="1" density="compact" />
                  <v-radio label="Date Modified" :value="2" density="compact"/>
                  <v-radio label="Date modified and received" value="3" density="compact" />
                </v-radio-group>

                <v-row no-gutters>
                  <v-col cols="12" sm="4">Date Range</v-col>
                  <v-col cols="12" sm="8">
                    <v-select variant="outlined" v-model="scanFilterStateV2.settings.scan.period" :items="Object.entries(scanFilterStateV2.periods).map(([value, title]) => ({ value, title }))" density="compact" />
                  </v-col>
                  <v-col v-if="scanFilterStateV2.settings.scan.period == 'custom'" cols="12">
                    <v-row no-gutters>
                      <v-col cols="12" sm="2">From</v-col>
                      <v-col class="mb-4" cols="12" sm="10">
                        <date-time-picker v-model:date-time="scanFilterStateV2.settings.scan.date_from" :selected="scanFilterStateV2.settings.scan.date_from" label="From" format= "MM/DD/YYYY hh:mm a" />
                      </v-col>
                      <v-col cols="12" sm="2">To</v-col>
                      <v-col class="mb-4" col="12" sm="10">
                        <date-time-picker v-model:date-time="scanFilterStateV2.settings.scan.date_to" :selected="scanFilterStateV2.settings.scan.date_to" label="To" format= "MM/DD/YYYY hh:mm a" />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-if="['last', 'older_than'].includes(scanFilterStateV2.settings.scan.period)" cols="12">
                    <v-row no-gutters>
                      <v-col cols="12" sm="4">{{ scanFilterStateV2.settings.scan.period === 'last' ? 'Last' : 'Older Than' }}</v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field variant="outlined" type="number" class="mr-1" density="compact" min="1" v-model="scanFilterStateV2.settings.scan.p_number" />
                      </v-col>
                      <v-col cols="12" sm="5">
                        <v-select variant="outlined" v-model="scanFilterStateV2.settings.scan.p_metric" :items="Object.entries(scanFilterStateV2.metrics).map(([value, title]) => ({ value, title }))" density="compact" />
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" sm="4">Timezone</v-col>
                  <v-col class="mb-4" cols="12" sm="8">
                    <timezone-list-component label="Timezone" v-model:value="scanFilterStateV2.settings.scan.timezone" :timezone-mode="scanFilterStateV2.settings.scan.timezone_mode" :preserve-timezone="scanFilterStateV2.preserveTimezone" />
                  </v-col>

                  <v-col cols="12" sm="4">Order By</v-col>
                  <v-col cols="12" sm="8">
                    <v-select variant="outlined" v-model="scanFilterStateV2.settings.scan.sort_by" :items="Object.entries(scanFilterStateV2.settings.scan.order_list).map(([value, title]) => ({ value, title }))" density="compact" hide-details />
                  </v-col>

                  <v-col cols="12">
                    <v-radio-group hide-details="true" v-model="scanFilterStateV2.settings.scan.sort_order" inline class="mt-4">
                      <v-radio label="Ascending" value="asc" density="compact" />
                      <v-radio label="Descending" value="desc" density="compact" />
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <v-expansion-panel :class="{ 'bg-grey-lighten-4 my-2': panel.includes(2) }" elevation="0">
              <v-expansion-panel-title class="font-weight-bold px-0 my-n3 text-body-2" hide-actions>
                <div class="bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2">
                  <v-icon class="mt-n1" size="x-large" :icon="panel.includes(2) ? 'mdi-menu-down' : 'mdi-menu-right'" /> <v-icon icon="mdi-view-module" />Scan Category
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-radio-group v-model="scanFilterStateV2.settings.scan.category" inline>
                  <v-radio label="All &nbsp;" value="all" density="compact" />
                  <v-radio label="Real-time &nbsp;" value="real_time" density="compact" />
                  <v-radio label="Uploaded &nbsp;" value="uploaded" density="compact" />
                </v-radio-group>

                <label class="mb-2 d-block">With these scan results:</label>
                <table class="table sm-th">
                  <tr v-if="scanResults">
                    <th class="valid handle" @click="[showValidColor = !showValidColor, checkScanResult('1')]" :class="{'valid-color': scanResults.indexOf('1') > -1}" id="valid">
                      <img :src="asset('icon/valid.png')"  class="visible-md-inline visible-lg-inline" alt="valid"/>Valid
                    </th>
                    <th class="invalid handle" @click="[showInvalidColor = !showInvalidColor,  checkScanResult('0')]" :class="{'invalid-color': scanResults.indexOf('0') > -1}" id="invalid">
                      <img :src="asset('icon/invalid.png')"  class="visible-md-inline visible-lg-inline" alt="invalid"/>Invalid
                    </th>
                    <th class="saved handle" @click="[showColor = !showColor,  checkScanResult('-1')]" :class="{'saved-color': scanResults.indexOf('-1') > -1}" id="saved">
                      <img :src="asset('icon/saved.png')"  class="visible-md-inline visible-lg-inline" alt="saved"/>Saved
                    </th>
                  </tr>
                </table>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <v-expansion-panel :class="{ 'bg-grey-lighten-4 my-2': panel.includes(3) }" elevation="0">
              <v-expansion-panel-title class="font-weight-bold px-0 my-n3 text-body-2" hide-actions>
                <div class="bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2">
                  <v-icon class="mt-n1" size="x-large" :icon="panel.includes(3) ? 'mdi-menu-down' : 'mdi-menu-right'" /> <v-icon icon="mdi-file" />Services
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div v-if="scanFilterStateV2.loadingServices" class="text-center">
                  <v-icon icon="mdi-loading"/> Loading Services
                </div>
                <div class="mt-2">
                  <service-selector v-if="!scanFilterStateV2.loadingServices"
                                    v-model="scanFilterStateV2.settings.services.selected_ids"
                                    :deleted-services="scanFilterStateV2.settings.services.deleted"
                                    :services-search-text="scanFilterStateV2.settings.services.search_text"
                                    :row="1"
                                    :select-all="scanFilterStateV2.settings.services.select_all"
                                    @update:selectAll="updateServiceSelectAll" usage="scan-filter" />
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <v-expansion-panel :class="{ 'bg-grey-lighten-4 my-2': panel.includes(4) }" elevation="0">
              <v-expansion-panel-title class="font-weight-bold px-0 my-n3 text-body-2" hide-actions>
                <div class="bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2">
                  <v-icon class="mt-n1" size="x-large" :icon="panel.includes(4) ? 'mdi-menu-down' : 'mdi-menu-right'" /> <v-icon icon="mdi-account" /> Users
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div v-if="scanFilterStateV2.loadingUsers" class="text-center">
                  <v-icon icon="mdi-loading" />Loading Users
                </div>
                <div class="mt-2">
                  <user-selector v-if="!scanFilterStateV2.loadingUsers" :users="scanFilterStateV2.users" v-model="scanFilterStateV2.settings.users.selected_ids"
                                 :show-include-deleted-users=true :deleted-users.sync="scanFilterStateV2.settings.users.deleted" @change-deleted-users="scanFilterStateV2.settings.users.deleted = $event" :users-search-text="scanFilterStateV2.settings.users.search_text"
                                 :row="1" :select-all="scanFilterStateV2.settings.users.select_all" :show-label="false" />
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <v-expansion-panel :class="{ 'bg-grey-lighten-4 my-2': panel.includes(5) }" elevation="0">
              <v-expansion-panel-title class="font-weight-bold px-0 my-n3 text-body-2" hide-actions>
                <div class="bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2">
                  <v-icon class="mt-n1" size="large" :icon="panel.includes(5) ? 'mdi-menu-down' : 'mdi-menu-right'" /> <v-icon icon="mdi-television" /> Devices
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div v-if="scanFilterStateV2.loadingDevices" class="text-center">
                  <v-icon icon="mdi-loading" />Loading Devices
                </div>
                <div class="mt-2">
                  <device-selector v-if="!scanFilterStateV2.loadingDevices" :devices="scanFilterStateV2.devices" v-model="scanFilterStateV2.settings.devices.selected_ids"
                                   :devices-search-text="scanFilterStateV2.settings.devices.search_text" :row="1" :select-all="scanFilterStateV2.settings.devices.select_all" />
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <v-expansion-panel :class="{ 'bg-grey-lighten-4 my-2': panel.includes(6) }" elevation="0" v-if="scanFilterStateV2.settings.template.show">
              <v-expansion-panel-title class="font-weight-bold px-0 my-n3 text-body-2" hide-actions>
                <div class="bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2">
                  <v-icon class="mt-n1" size="large" :icon="panel.includes(6) ? 'mdi-menu-down' : 'mdi-menu-right'" /> <v-icon icon="mdi-file-export" /> Export template
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div class="mt-2">
                  <template-list v-model="scanFilterStateV2.settings.template.id" :field-container-title="'Your CSV export will contain the following columns:'" :label="'Output Format:'"
                                 :additional-options="{'regular': 'All Data except properties (default)', 'regwithprops': 'All Data (including properties)'}" />
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>

          </v-expansion-panels>
          <br />
          <v-btn class="text-none" block :disabled="scanFilterStateV2.loadingServices" color="black" type="submit" v-if="scanFilterStateV2.settings.showFilterButton">Filter</v-btn>
          <v-btn class="text-none mt-3" color="black" block @click="showScans" v-if="scanFilterStateV2.settings.showViewScansButton">View Scans</v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showScansModal" max-width="800">
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>Filtered Scans</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showScansModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <h1 v-show="scanFilterStateV2.isLoading" class="text-center text-muted">
            <v-progress-circular indeterminate></v-progress-circular>
            <small>Loading, please wait...</small>
          </h1>
          <div v-if="!scanFilterStateV2.isLoading">
            <div>
              <h4 class="text-center">
                {{ scanFilterStateV2['paginator']['offset'] + 1 }} - {{ scanFilterStateV2['paginator']['offset'] + scanFilterStateV2['scans'].length }} of
                <v-progress-circular v-show="scanFilterStateV2.isLoadingScansCount" indeterminate size="24"></v-progress-circular>
                <span v-show="!scanFilterStateV2.isLoadingScansCount">
                  {{ parseInt(scanFilterStateV2['paginator']['totalCount']) }}{{ scanFilterStateV2['paginator']['totalCount'] == scanFilterStateV2['defaultTotalCount'] ? '+' : ''}}
                </span> Scans
              </h4>
              <pagination :paginator-data="scanFilterStateV2['paginator']" :nav="false" v-if="scanFilterStateV2['paginator']['totalCount'] > 0" />
            </div>
            <div v-if="scanFilterStateV2.scans.length == 0" class="text-center">
              <h3>No Scans Found.</h3>
            </div>
            <div v-if="scanFilterStateV2.scans.length > 0 && showScansModal">
              <div v-for="scan in scanFilterStateV2.scans" :key="scan.id">
                <scan-card :scan="scan" :received="scanFilterStateV2.settings.scan.data_received" :scanFilterStateV2="scanFilterStateV2" />
              </div>
            </div>
            <pagination :paginator-data="scanFilterStateV2['paginator']" :nav="false" v-if="scanFilterStateV2['paginator']['totalCount'] > 0" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, computed } from 'vue';
import { useRoute, onBeforeRouteUpdate, useRouter } from 'vue-router';
import moment from 'moment';
import Paginator from '../service/PaginatorService';
import asset from '../service/AssetService';
import util from '../service/UtilService';
import flashMessenger from '../service/FlashMessenger';
import TimezoneListComponent from "./TimezoneListComponent.vue";

const props = defineProps({
  scanFilterStateV2: {
    type: Object,
    required: true
  },
  expandDateSectionByDefault: {
    type: Boolean,
    default: true
  }
});
const route = useRoute();
const router = useRouter();
const showScansModal = ref(false);
const showValidColor = ref(true);
const showInvalidColor = ref(true);
const showColor = ref(true);
const scanResults = ref(util.clone(props.scanFilterStateV2.settings.scan.result));
const scanClone = ref(util.clone(props.scanFilterStateV2.settings.scan));
const showValueMore = ref(false);
const showResponseMore = ref(false);
const showPropertyName = ref(false);
const showPropertyValue = ref(false);
const showAnswerMore = ref(false);
const showScansStartDate = ref('');
const showScansEndDate = ref('');
const uploadTimestamps = ref([]);
const serviceNames = ref([]);
const userNames = ref([]);
const deviceNames = ref([]);
const deletedServices = ref(util.clone(props.scanFilterStateV2.settings.services.deleted) || false);
const deletedUsers = ref(util.clone(props.scanFilterStateV2.settings.users.deleted) || false);
const services = ref(util.clone(props.scanFilterStateV2.settings.services.selected_ids) == undefined ? 'all' : util.clone(props.scanFilterStateV2.settings.services.selected_ids));
const users = ref(util.clone(props.scanFilterStateV2.settings.users.selected_ids) || 'all');
const scanStartDate = ref(util.clone(props.scanFilterStateV2.settings.scan.start_date) || '');
const scanEndDate = ref(util.clone(props.scanFilterStateV2.settings.scan.end_date) || '');
const scanDateFrom = ref(util.clone(props.scanFilterStateV2.settings.scan.date_from) || '');
const scanDateTo = ref(util.clone(props.scanFilterStateV2.settings.scan.date_to) || '');
const uploads = ref(util.clone(props.scanFilterStateV2.settings.scan.upload_ids) || []);
const devices = ref(util.clone(props.scanFilterStateV2.settings.devices.selected_ids) || []);
const displayFilters = ref((route.name as string).substring(0, 13) === 'account.scans');
const open = ref(['Users']);
const panel = ref(props.expandDateSectionByDefault ? [1] : []);

onBeforeRouteUpdate((to, from, next) => {
  scanResults.value = util.clone(props.scanFilterStateV2.settings.scan.result);
  scanClone.value = util.clone(props.scanFilterStateV2.settings.scan);
  deletedServices.value = util.clone(props.scanFilterStateV2.settings.services.deleted) || false;
  deletedUsers.value = util.clone(props.scanFilterStateV2.settings.users.deleted) || false;
  services.value = util.clone(props.scanFilterStateV2.settings.services.selected_ids) == undefined ? 'all' : util.clone(props.scanFilterStateV2.settings.services.selected_ids);
  users.value = util.clone(props.scanFilterStateV2.settings.users.selected_ids) || 'all';
  scanStartDate.value = util.clone(props.scanFilterStateV2.settings.scan.start_date) || '';
  scanEndDate.value = util.clone(props.scanFilterStateV2.settings.scan.end_date) || '';
  scanDateFrom.value = util.clone(props.scanFilterStateV2.settings.scan.date_from) || '';
  scanDateTo.value = util.clone(props.scanFilterStateV2.settings.scan.date_to) || '';
  uploads.value = util.clone(props.scanFilterStateV2.settings.scan.upload_ids) || [];
  devices.value = util.clone(props.scanFilterStateV2.settings.devices.selected_ids) || [];

  serviceNames.value = [];
  userNames.value = [];
  deviceNames.value = [];
  uploadTimestamps.value = [];

  next();

});

function updateServiceSelectAll(value: boolean) {
  props.scanFilterStateV2.settings.services.select_all = value;
}

function createPaginator() {
  props.scanFilterStateV2.paginator = new Paginator(() => {
    props.scanFilterStateV2.loadScans();
  });
}
watch(showScansModal, (newVal) => {
  if (newVal) {
    createPaginator();
  }
});

/*watch(() => props.scanFilterStateV2.paginator.currentPage, (newVal) => {
  props.scanFilterStateV2.loadScans()
});*/

watch(() => props.scanFilterStateV2.showScansStart, (newVal) => {
      if (newVal && props.scanFilterStateV2.showScansEnd) {
        showScansStartDate.value = moment(newVal, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
        showScansEndDate.value = moment(props.scanFilterStateV2.showScansEnd, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
      } else {
        showScansStartDate.value = '';
        showScansEndDate.value = '';
      }
    },
    { deep: true }
);

watch(() => props.scanFilterStateV2.settings.scan.p_metric, (newValue) => {
      if (newValue === 'minute' && (props.scanFilterStateV2.settings.scan.p_number < 10 || props.scanFilterStateV2.settings.scan.p_number === '')) {
        props.scanFilterStateV2.settings.scan.p_number = 10;
      }
    },
    {immediate: true}
);

watch(() => props.scanFilterStateV2.settings.scan.timezone, (newTimezone) => {
      if (props.scanFilterStateV2.preserveTimezone) {
        if (window.localStorage) {
          window.localStorage.setItem('cr-selected-timezone', newTimezone);
        }
      }
    },
    { deep: true }
);

watch(() =>props.scanFilterStateV2.uploads, (newUploads) => {
      if (!props.scanFilterStateV2.loadingUploads && newUploads.length > 0) {
        const newTimestamps = [];
        for (let upload of newUploads) {
          if (props.scanFilterStateV2.uploads && props.scanFilterStateV2.uploads.includes(upload.uploadId)) {
            newTimestamps.push(upload.timestamp);
          }
        }
        //@ts-ignore
        uploadTimestamps.value = newTimestamps.join(', ');
      }
    },
    { deep: true }
);

watch(() => [props.scanFilterStateV2.loadingServices, props.scanFilterStateV2.services, services.value], ([newLoading, newServices, localServices], [oldLoading, oldServices, oldLocalServices]) => {
      if (!newLoading && newServices.length > 0 && !props.scanFilterStateV2.services.select_all) {
        if (localServices !== 'all' && Array.isArray(localServices) && localServices.length > 0) {
          const newServiceNames = [];
          for (let s of newServices) {
            if (localServices.includes(s.serviceId)) {
              newServiceNames.push(s.serviceName);
            }
          }
          //@ts-ignore
          serviceNames.value = newServiceNames.join(', ');
        } else {
          serviceNames.value = [];
        }
      }
    },
    { deep: true }
);

watch(() => [props.scanFilterStateV2.loadingUsers, props.scanFilterStateV2.users, users.value], ([newLoadingUsers, newUsers, localUsers]) => {
      if (!newLoadingUsers && newUsers.length > 0) {
        if (localUsers !== 'all' && Array.isArray(localUsers) && localUsers.length > 0) {
          const newUserNames = [];
          for (let u of newUsers) {
            if (localUsers.includes(u.userId)) {
              newUserNames.push(u.username);
            }
          }
          //@ts-ignore
          userNames.value = newUserNames.join(', ');
        } else {
          userNames.value = []; // Reset if conditions not met
        }
      }
    },
    { deep: true }
);

watch(() => [props.scanFilterStateV2.loadingDevices, props.scanFilterStateV2.devices, devices.value], ([newLoadingDevices, newDevices, localDevices]) => {
      if (!newLoadingDevices && newDevices.length > 0) {
        if (localDevices !== 'all' && Array.isArray(localDevices) && localDevices.length > 0) {
          const newDeviceNames = [];
          for (let d of newDevices) {
            if (localDevices.includes(d.deviceId)) {
              newDeviceNames.push(d.deviceName);
            }
          }
          //@ts-ignore
          deviceNames.value = newDeviceNames.join(', ');
        } else {
          deviceNames.value = []; // Reset if conditions not met
        }
      }
    },
    { deep: true }
);


onMounted(() => {
  createPaginator();
});

function validateScanIds(ids) {
  props.scanFilterStateV2.showErrorForScanIds = false;
  for (let id of ids.replace(/\s/g, '').split(',')) {
    if (id !== '') {
      props.scanFilterStateV2.showErrorForScanIds = id.match(/^[0-9]+$/) === null;
    }
  }
}

function checkScanResult(value) {
  const index = scanResults.value.indexOf(value);
  if (index < 0) {
    scanResults.value.push(value);
    props.scanFilterStateV2.settings.scan.result.push(value);
  } else {
    scanResults.value.splice(index, 1);
    props.scanFilterStateV2.settings.scan.result.splice(index, 1);
  }
}

async function showScans() {
  showScansModal.value = true;
  props.scanFilterStateV2.paginator.offset = 0;
  props.scanFilterStateV2.paginator.itemsPerPage = 10;
  await props.scanFilterStateV2.loadScans();
}

async function filter(filterType) {
  if (props.scanFilterStateV2.showErrorForScanIds) {
    return  flashMessenger.toastById('REQ_PARAMS', 'danger');
  }

  let params = {};

  params[props.scanFilterStateV2.urlMapping['value']] = props.scanFilterStateV2.settings.scan.value;
  if (props.scanFilterStateV2.settings.scan.value != '') {
    params[props.scanFilterStateV2.urlMapping['exact_value']] = props.scanFilterStateV2.settings.scan.exact_value ? 'true' : 'false';
    params[props.scanFilterStateV2.urlMapping['value_ci']] = props.scanFilterStateV2.settings.scan.value_ci  ? 'true' : 'false';
  }
  params[props.scanFilterStateV2.urlMapping['response']] = props.scanFilterStateV2.settings.scan.response;
  if (props.scanFilterStateV2.settings.scan.response != '') {
    params[props.scanFilterStateV2.urlMapping['exact_response']] = props.scanFilterStateV2.settings.scan.exact_response  ? 'true' : 'false';
    params[props.scanFilterStateV2.urlMapping['response_ci']] = props.scanFilterStateV2.settings.scan.response_ci  ? 'true' : 'false';
  }

  params[props.scanFilterStateV2.urlMapping['scan_ids']] = props.scanFilterStateV2.settings.scan.selected_ids.replace(/\s/g,'');

  params[props.scanFilterStateV2.urlMapping['answer']] = props.scanFilterStateV2.settings.scan.answer;
  if (props.scanFilterStateV2.settings.scan.answer != '') {
    params[props.scanFilterStateV2.urlMapping['exact_answer']] = props.scanFilterStateV2.settings.scan.exact_answer  ? 'true' : 'false';
  }

  params[props.scanFilterStateV2.urlMapping['property_name']] = props.scanFilterStateV2.settings.scan.property_name;
  params[props.scanFilterStateV2.urlMapping['property_value']] = props.scanFilterStateV2.settings.scan.property_value;
  params[props.scanFilterStateV2.urlMapping['recent_scan']] = props.scanFilterStateV2.settings.scan.recent_scan  ? 'true' : 'false';
  params[props.scanFilterStateV2.urlMapping['table_builder_scan']] = props.scanFilterStateV2.settings.scan.table_builder_scan  ? 'true' : 'false';
  params[props.scanFilterStateV2.urlMapping['exclude_table_builder_scan']] = props.scanFilterStateV2.settings.scan.exclude_table_builder_scan  ? 'true' : 'false';
  params[props.scanFilterStateV2.urlMapping['check_in_out_scan']] = props.scanFilterStateV2.settings.scan.check_in_out_scan  ? 'true' : 'false';
  params[props.scanFilterStateV2.urlMapping['exclude_check_in_out_scan']] = props.scanFilterStateV2.settings.scan.exclude_check_in_out_scan  ? 'true' : 'false';
  params[props.scanFilterStateV2.urlMapping['data_received']] = props.scanFilterStateV2.settings.scan.data_received;

  if (props.scanFilterStateV2.settings.scan.date_from != null && props.scanFilterStateV2.settings.scan.date_from != '') {
    if (!moment.isMoment(props.scanFilterStateV2.settings.scan.date_from)) {
      let dateFrom = new Date(props.scanFilterStateV2.settings.scan.date_from);
      props.scanFilterStateV2.settings.scan.date_from =  moment().set({
        y: dateFrom.getFullYear(),
        M: dateFrom.getMonth(),
        D: dateFrom.getDate(),
        h: dateFrom.getHours(),
        m: dateFrom.getMinutes(),
        s: dateFrom.getSeconds()
      });
    }

    params[props.scanFilterStateV2.urlMapping['start_date']] = props.scanFilterStateV2.settings.scan.date_from.format('YYYY-MM-DD');
    params[props.scanFilterStateV2.urlMapping['start_time']] = props.scanFilterStateV2.settings.scan.date_from.format('HH:mm:ss');

    if (props.scanFilterStateV2.settings.scan.period != 'custom') {
      params[props.scanFilterStateV2.urlMapping['start_date']]='';
      params[props.scanFilterStateV2.urlMapping['start_time']]='';
    }
  } else {
    params[props.scanFilterStateV2.urlMapping['start_date']]='';
    params[props.scanFilterStateV2.urlMapping['start_time']]='';
  }

  if (props.scanFilterStateV2.settings.scan.date_to != null && props.scanFilterStateV2.settings.scan.date_to != '') {
    if (!moment.isMoment(props.scanFilterStateV2.settings.scan.date_to)) {
      let dateTo = new Date(props.scanFilterStateV2.settings.scan.date_to);
      props.scanFilterStateV2.settings.scan.date_to =  moment().set({
        y: dateTo.getFullYear(),
        M: dateTo.getMonth(),
        D: dateTo.getDate(),
        h: dateTo.getHours(),
        m: dateTo.getMinutes(),
        s: dateTo.getSeconds()
      });
    }

    params[props.scanFilterStateV2.urlMapping['end_date']] = props.scanFilterStateV2.settings.scan.date_to.format('YYYY-MM-DD');
    params[props.scanFilterStateV2.urlMapping['end_time']] = props.scanFilterStateV2.settings.scan.date_to.format('HH:mm:ss');
    if (props.scanFilterStateV2.settings.scan.period != 'custom') {
      params[props.scanFilterStateV2.urlMapping['end_date']]='';
      params[props.scanFilterStateV2.urlMapping['end_time']]='';
    }
  } else {
    params[props.scanFilterStateV2.urlMapping['end_date']]='';
    params[props.scanFilterStateV2.urlMapping['end_time']]='';
  }

  params[props.scanFilterStateV2.urlMapping['period']] = props.scanFilterStateV2.settings.scan.period != '' && props.scanFilterStateV2.settings.scan.period != null ? props.scanFilterStateV2.settings.scan.period : 'last_30_days';

  if (props.scanFilterStateV2.settings.scan.period == 'last') {
    params[props.scanFilterStateV2.urlMapping['p_metric']] = props.scanFilterStateV2.settings.scan.p_metric;
    params[props.scanFilterStateV2.urlMapping['p_number']] = props.scanFilterStateV2.settings.scan.p_number;
  } else if (props.scanFilterStateV2.settings.scan.period == 'older_than') {
    params[props.scanFilterStateV2.urlMapping['p_metric']] = props.scanFilterStateV2.settings.scan.p_metric;
    params[props.scanFilterStateV2.urlMapping['p_number']] = props.scanFilterStateV2.settings.scan.p_number;
  } else {
    params[props.scanFilterStateV2.urlMapping['p_metric']] = '';
    params[props.scanFilterStateV2.urlMapping['p_number']] = 1;
  }

  params[props.scanFilterStateV2.urlMapping['tz']] = props.scanFilterStateV2.settings.scan.timezone;

  if (props.scanFilterStateV2.settings.scan.sort_order == 'asc') {
    params[props.scanFilterStateV2.urlMapping['sort_order']] = 'asc';
  } else {
    params[props.scanFilterStateV2.urlMapping['sort_order']] = 'desc';
  }

  if (props.scanFilterStateV2.settings.scan.sort_by) {
    params[props.scanFilterStateV2.urlMapping['sort_by']] = props.scanFilterStateV2.settings.scan.sort_by;
  }

  if (props.scanFilterStateV2.settings.scan.category != '') {
    params[props.scanFilterStateV2.urlMapping['category']] = props.scanFilterStateV2.settings.scan.category;
  }

  if (scanResults.value.length == 3 && scanResults.value.indexOf('0') != -1  &&
      scanResults.value.indexOf('1') != -1 && scanResults.value.indexOf('-1') != -1) {
    params['result'] = 'all';
  } else {
    params[props.scanFilterStateV2.urlMapping['result']] = scanResults.value.length == 0 ? '' : scanResults.value.join(',');
  }

  params[props.scanFilterStateV2.urlMapping['u_deleted']] = props.scanFilterStateV2.settings.users.deleted ? 1 : 0;

  if (props.scanFilterStateV2.settings.scan.upload_ids.length == 0) {
    params[props.scanFilterStateV2.urlMapping['upload_ids']] = '0';
  } else {
    params[props.scanFilterStateV2.urlMapping['upload_ids']] = props.scanFilterStateV2.settings.scan.upload_ids.join(',');
  }

  if (props.scanFilterStateV2.settings.users.selected_ids.length == 0) {
    params[props.scanFilterStateV2.urlMapping['user_ids']] = '0';
  } else {
    params[props.scanFilterStateV2.urlMapping['user_ids']] = props.scanFilterStateV2.settings.users.selected_ids.join(',');

    if (props.scanFilterStateV2.settings.users.selected_ids.length == props.scanFilterStateV2.users.length) {
      params[props.scanFilterStateV2.urlMapping['user_ids']] = 'all';
    }
  }


  params[props.scanFilterStateV2.urlMapping['s_deleted']] = props.scanFilterStateV2.settings.services.deleted ? 1 : 0;

  if (props.scanFilterStateV2.settings.services.selected_ids.length == 0 && props.scanFilterStateV2.settings.services.select_all === true) {
    params[props.scanFilterStateV2.urlMapping['service_ids']] = 'all';
  } else if (props.scanFilterStateV2.settings.services.selected_ids.length == 0 && props.scanFilterStateV2.settings.services.select_all === false) {
    params[props.scanFilterStateV2.urlMapping['service_ids']] = '0';
  } else {
    params[props.scanFilterStateV2.urlMapping['service_ids']] = props.scanFilterStateV2.settings.services.selected_ids.join(',');
  }
  /*if (props.scanFilterStateV2.settings.services.selected_ids.length == 0 && props.scanFilterStateV2.settings.services.select_all === false) {
    params[props.scanFilterStateV2.urlMapping['service_ids']] = '0';
  } else {
    params[props.scanFilterStateV2.urlMapping['service_ids']] = props.scanFilterStateV2.settings.services.selected_ids.join(',');

    if (props.scanFilterStateV2.settings.services.selected_ids.length == props.scanFilterStateV2.services.length) {
      params[props.scanFilterStateV2.urlMapping['service_ids']] = 'all';
    }
  }*/

  if (props.scanFilterStateV2.settings.devices.selected_ids.length == 0) {
    params[props.scanFilterStateV2.urlMapping['device_ids']] = '0';
  } else {
    params[props.scanFilterStateV2.urlMapping['device_ids']] = props.scanFilterStateV2.settings.devices.selected_ids.join(',');

    if (props.scanFilterStateV2.settings.devices.selected_ids.length == props.scanFilterStateV2.devices.length) {
      params[props.scanFilterStateV2.urlMapping['device_ids']] = 'all';
    }
  }

  if (props.scanFilterStateV2.settings.template.show) {
    params[props.scanFilterStateV2.urlMapping['template']] = props.scanFilterStateV2.settings.template.id;
  }

  params['limit'] = props.scanFilterStateV2.countScansInPerPage;

  if (filterType == 'view') {
    return params;
  }
  params['page'] = 1;
  await router.push({ name: route.name,
    query: Object.assign(
        {},
        route.query,
        params
    )
  });
}

function getDate(date, format) {
  if (Array.isArray(date)) {
    date = date[0];
  }
  return moment(date).format(format);
}

async function removeSearchParameter(searchParams) {
  let q = {};
  for (let p of searchParams) {
    if (p == 'value') {
      q['value'] = '';
      q['exact_value'] = 'false';
      q['value_ci'] = 'false';
    } else if (p == 'response') {
      q['response'] = '';
      q['exact_response'] = 'false';
      q['response_ci'] = 'false';
    } else if (p == 'answer') {
      q['answer'] = '';
      q['exact_answer'] = 'false';
    } else if (p == 'property') {
      q['property_name'] = '';
      q['property_value'] = '';
    } else if (p == 'recent_scan') {
      q['recent_scan'] = 'false';
    } else if (p == 'start_date') {
      q['start_date'] = '';
      if (typeof route.query["start_time"] != 'undefined') {
        q['start_time'] = '';
      }
    } else if (p == 'end_date') {
      q['end_date'] = '';
      if (typeof route.query["end_time"] != 'undefined') {
        q['end_time'] = '';
      }
    } else if (p == 'period') {
      q['period'] = 'last_30_day';
    } else if (p == 'p_number') {
      q['p_number'] = 1;
    } else if (p == 'p_metric') {
      q['p_metric'] = '';
    } else if (p == 'category') {
      q['category'] = 'all';
    } else if (p == 'result') {
      q['result'] = 'all';
    } else if (p == 'd_services') {
      q['s_deleted'] = 0;
    } else if (p == 'service_ids') {
      q['service_ids'] = 'all';
    } else if (p == 'd_users') {
      q['u_deleted'] = 0;
    } else if (p == 'user_ids') {
      q['user_ids'] = 'all';
    } else if (p == 'device_ids') {
      q['device_ids'] = 'all';
    } else if (p == 'scan_ids') {
      q['scan_ids'] = '';
    } else if (p == 'uploads') {
      q['upload_ids'] = 0;
    } else if (p == 'table_builder_scan') {
      q['table_builder_scan'] = '';
    }  else if (p == 'exclude_table_builder_scan') {
      q['exclude_table_builder_scan'] = '';
    }  else if (p == 'check_in_out_scan') {
      q['check_in_out_scan'] = '';
    }  else if (p == 'exclude_check_in_out_scan') {
      q['exclude_check_in_out_scan'] = '';
    }
  }

  q['page'] = 1;

  await router.push({ name: route.name, query: Object.assign({}, route.query, q)});
}

</script>

<style lang="scss" scoped>
:deep(.v-expansion-panel-text__wrapper) {
  margin-top: -18px!important;
}

.sm-th th {
  padding: 0.25rem;
}
.page-scans-filter {
  a {
    cursor: pointer !important;
  }

  .m8 {
    margin: 8px;
  }
  .handle {
    cursor: pointer !important;
  }
  .grey {
    color: grey !important;
  }
  ul {
    list-style: none;
    padding-left: 0 !important;
  }
  .number-width {
    width: 62px;
  }
  .pr12 {
    padding-right: 12px;
  }
  .deleted {
    background-color: rgba(255, 151, 151, 0.3);
  }
  .filter-weight {
    font-weight: 300;
  }
  label {
    word-wrap: break-word;
  }
  .break-word {
    word-wrap: break-word;
  }
  .bubble {
    border-radius: 8px;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.4);
    background: #fff;
    background: rgba(255, 255, 255, 0.7);
    display: inline-block;
    b {
      font-weight: normal;
    }
    padding: 0 5px;
    margin-bottom: 3px;
  }
  .display-block {
    display: block;
  }
  .properties, .questions {
    background: #b5bfd7;
    border: 1px solid #8390a8;
    border-radius: 4px;
    padding: 4px;
    .handle {
      cursor: pointer !important;
    }
  }
  table {
    border-collapse: inherit;
    th {
      text-align: center;
    }
    .valid {
      border-bottom-left-radius: 15px;
      border-top-left-radius: 15px;
      border: 1px solid rgba(0, 0, 0, 0.3);
      &.valid-color {
        background-color: #80ff80;
      }
    }
    .saved {
      border-bottom-right-radius: 15px;
      border-top-right-radius: 15px;
      border: 1px solid rgba(0, 0, 0, 0.3);
      &.saved-color {
        background-color: #fff480;
      }
    }
    .invalid {
      border: 1px solid rgba(0, 0, 0, 0.3);
      &.invalid-color {
        background-color: #ff8080;
      }
    }
  }
  .bg-color {
    background-color: #eeeeee !important;
  }
  .template-box {
    padding: 10px 10px;
    border-radius: 5px;
    border: 1px solid silver;
  }
  .scroll {
    overflow: auto;
    max-height: 400px;
    overflow-x: hidden;
  }
  .remove-underline {
    a:link {
      text-decoration: none !important;
    }
  }
}

.filter-chip {
  border: 1px solid;
  border-radius: 10px;
  display: inline-block;
  padding: 5px;
  font-size: 16px;
  max-width: 100%;
}

:deep(.v-expansion-panel-title__overlay) {
  background-color: white !important;
  border: none !important;
}

:deep(.v-expansion-panels--variant-accordion > .v-expansion-panel::after) {
  display: none;
}

:deep(.v-selection-control .v-label) {
  font-size:16px;
}
</style>